/**
 * Iter XX.242 · Cricket Graph V1 — /cricket page.
 *
 * Free-tier `Your Cricket` surface. Distinct from the Plus-gated
 * `/my-cricket` (XX.174). Now with an inline "Edit My Cricket" panel
 * (XX.242a).
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CricketGraphCard from "../components/CricketGraphCard";
import EditCricketProfile from "../components/EditCricketProfile";
import { fetchCricketGraph } from "../lib/cricketGraph";

export default function CricketPage() {
  const navigate = useNavigate();
  const [graph, setGraph] = useState(null);
  const [editing, setEditing] = useState(false);
  const [nonce, setNonce] = useState(0);  // remount card after edits

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const g = await fetchCricketGraph();
      if (!cancelled) setGraph(g);
    })();
    return () => { cancelled = true; };
  }, [nonce]);

  const canEdit = !!graph && graph.state !== "first_time";

  return (
    <div
      data-testid="cricket-page"
      className="min-h-screen bg-neutral-950 text-neutral-100"
    >
      <div className="mx-auto max-w-2xl px-5 pt-8 pb-24">
        <div className="flex items-center justify-between gap-3 mb-6">
          <button
            data-testid="cricket-page-back"
            onClick={() => navigate("/chat")}
            className="text-[13px] text-neutral-500 hover:text-neutral-300 transition-colors"
          >
            ← Back to chat
          </button>
          {canEdit && !editing && (
            <div className="flex items-center gap-3">
              <button
                data-testid="cricket-page-edit"
                onClick={() => setEditing(true)}
                className="text-[13px] text-emerald-500 hover:text-emerald-400 transition-colors"
              >
                Edit my cricket
              </button>
              <a
                data-testid="cricket-page-pulse-profile"
                href="/pulse"
                className="text-[13px] text-neutral-400 hover:text-neutral-200 transition-colors"
              >
                My public profile →
              </a>
            </div>
          )}
        </div>

        <h1 data-testid="cricket-page-title" className="text-3xl font-medium mb-2">
          Your Cricket
        </h1>
        <p data-testid="cricket-page-subtitle" className="text-[14px] text-neutral-400 mb-6">
          This gets better as you play. Your cricket won't start from zero again.
        </p>

        {editing ? (
          <EditCricketProfile
            initial={graph}
            onCancel={() => setEditing(false)}
            onSaved={() => { setEditing(false); setNonce((n) => n + 1); }}
          />
        ) : (
          <CricketGraphCard onOpenChat={() => navigate("/chat")} key={nonce} />
        )}
      </div>
    </div>
  );
}
